import { ITerrrainRunsOnly } from 'api/resort/types';
import { TerrainShortSlopeType, terrainShortSlopeTypes } from 'components/resort/TerrainShort/constants';
import { DistanceFormatterFn } from 'i18n/unitFormat';

export type TerrainDataItem = {
  type: TerrainShortSlopeType,
  len?: string,
  count?: string,
  percent?: string,
};
export type TerrainData = Array<TerrainDataItem>;

export type TerrainKeyType = 'len' | 'count' | 'percent';
export const keyTypes: Array<TerrainKeyType> = ['len', 'count', 'percent'];

/**
 * Builds all types of data to output based on their availability
 * @param runs
 * @param df
 * @param t
 */
export const terrainData = (runs: ITerrrainRunsOnly, df: DistanceFormatterFn, t: (k: I18nKeyGenerated['common']) => string) => {
  const dataMap: TerrainData = terrainShortSlopeTypes.map((type) => ({
    type,
    len: runs[type]?.totalLen && runs[type]?.openLen !== null
      ? df(
        [runs[type]?.openLen, runs[type]?.totalLen],
        '/',
        undefined,
        false,
        false,
        t('common.na'),
      ) : undefined, // builds data in distance open
    count: runs[type]?.total && runs[type]?.openNum !== null
      ? `${runs[type]?.openNum}/${runs[type]?.total}`
      : undefined, // data in numbers open
    percent: runs[type]?.openPercent ? `${runs[type]?.openPercent.toFixed(0)}%` : undefined, // data in percent open
  }));

  return dataMap;
};

/**
 * Returns number of non-empty data per type
 * @param data
 */
export const keyType = (data: TerrainData, runs: ITerrrainRunsOnly) => {
  const result: Record<TerrainKeyType | 'openLen' | 'openCount', number> = {
    percent: 0,
    count: 0,
    len: 0,
    openLen: 0,
    openCount: 0,
  };
  data.forEach((item: TerrainDataItem) => {
    keyTypes.forEach((k: TerrainKeyType) => {
      if (item[k]) {
        // eslint-disable-next-line no-plusplus
        result[k]++;
      }
    });
    if (runs[item.type]?.openLen) {
      // eslint-disable-next-line no-plusplus
      result.openLen++;
    }
    if (runs[item.type]?.openNum) {
      // eslint-disable-next-line no-plusplus
      result.openCount++;
    }
  });
  // console.log(result);
  return result;
};

export const chooseKeyType = (bias: Record<TerrainKeyType | 'openLen' | 'openCount', number>, preferKm: boolean) => {
  /** Prefers percent if no open data are available
   * Than fallback to km or count even if it's 0/N
   * Only then fallback again to percent */
  if (preferKm) {
    if (!bias.openLen && bias.percent) {
      return 'percent' as TerrainKeyType;
    }
    if (bias.len) {
      return 'len' as TerrainKeyType;
    }
  } else {
    if (!bias.openCount && bias.percent) {
      return 'percent' as TerrainKeyType;
    }
    if (bias.count) {
      return 'count' as TerrainKeyType;
    }
  }
  if (bias.percent) {
    return 'percent';
  }
  return undefined; // None of data is available
};
